<template>
  <div class="poll_page">
    <div class="poll_page_header">
      <div class="poll_page_header_icon">
        <span class="material-icons">navigate_before</span>
      </div>
      <div class="poll_page_header_title">
        ¿Por qué quieres aprender el idioma?
      </div>
    </div>
    <div class="poll_page_reasons">
      <div
        class="block_item"
        v-for="(item, index) in interestList"
        :key="index"
      >
        <div
          class="poll_page_reasons_item"
          @click="setActive(item)"
          :class="
            selectedInterest && selectedInterest.id == item.id ? 'active' : ''
          "
        >
          <div class="icons" :class="item.icon"></div>
          <div class="item_name">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <div class="poll_page_questions">
      <div class="question-group">
        <div class="question">
          ¿Has estudiado anteriormente en otro centro de idiomas?
        </div>
        <div>
          <v-radio-group v-model="radiosStudies" :mandatory="false" row>
            <v-radio color="#41424E" value="1">
              <template v-slot:label>
                <div class="label_radio_button">Sí</div>
              </template>
            </v-radio>
            <v-radio color="#41424E" value="0">
              <template v-slot:label>
                <div class="label_radio_button">No</div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
      </div>

      <div class="question-group" v-if="radiosStudies == 1">
        <div class="question">
          ¿En qué institución?
        </div>
        <div>
          <v-select
            :items="institutes"
            v-model="languageCenter"
            label="Seleccionar"
            menu-props="auto"
            hide-details
            single-line
            item-text="description"
            item-value="value"
          >
          </v-select>
        </div>
      </div>

      <div class="question-group">
        <div class="question">
          ¿Cómo te enteraste del curso en el que deseas inscribirte?
        </div>
        <div>
          <v-select
            :items="social"
            v-model="howYouKnew"
            label="Selecionar"
            menu-props="auto"
            hide-details
            single-line
            item-text="description"
            item-value="value"
          >
          </v-select>
        </div>
      </div>
    </div>
    <div class="poll_page_footer">
      <router-link to="/principal" class="go_previous">
        <v-icon style="font-size: 20px">navigate_before</v-icon> Anterior
      </router-link>

      <v-btn color="primary" class="uppercase" @click="next" :loading="loading">
        Continuar <v-icon style="font-size: 20px">navigate_next</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import axios from "@/axios-auth";

export default {
  data() {
    return {
      user: null,
      radiosStudies: -1,
      institutes: ["Brintánico", "Católica", "Euroidiomas"],
      social: ["Facebook", "Google", "Instagram"],
      interestList: [
        {
          id: 1,
          icon: "travels",
          label: "Viajes"
        },
        {
          id: 2,
          icon: "studies",
          label: "Estudios"
        },
        {
          id: 3,
          icon: "opportunities",
          label: "Oportunidades Laborales"
        },
        {
          id: 4,
          icon: "friends",
          label: "Amigos y Familia"
        },
        {
          id: 5,
          icon: "others",
          label: "Otros"
        }
      ],
      selectedInterest: null,
      languageCenter: "",
      howYouKnew: "",
      loading: false
    };
  },
  methods: {
    ...mapActions(["verifyPostulation"]),
    setActive(item) {
      this.selectedInterest = item;
    },
    saveInterest() {
      this.loading = true;
      let obj = {
        application_id: this.postulation.id,
        interest: this.selectedInterest.label,
        has_other_old_language_center: this.radiosStudies == 1 ? true : false,
        language_center: this.languageCenter,
        how_you_knew: this.howYouKnew
      };
      axios
        .post(`users/register-program-of-interest/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          this.loading = false;
          if (this.program.require_evaluation) {
            this.$router.push({ path: `/exam` });
          } else if (this.program.require_interview) {
            this.$router.push({ path: `/evaluation/schedule` });
          } else if (
            !this.program.require_evaluation &&
            !this.program.require_interview
          ) {
            this.$router.push({ path: `/principal` });
          }
        })
        .catch(err => {
          this.loading = false;
          console.error(err);
        });
    },
    loadOthers() {
      axios
        .get(`users/others/`, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          let others = response.data;
          if (others) {
            this.institutes = others.filter(o => o.attribute === "Institucion");
            this.social = others.filter(o => o.attribute === "Referencia");
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    next() {
      if (
        this.selectedInterest &&
        this.radiosStudies != -1 &&
        this.howYouKnew
      ) {
        if (this.radiosStudies == 1 && this.languageCenter == "") {
          alert("Seleccionar institución");
          return;
        }
        this.saveInterest();
      } else {
        alert("Seleccionar la información de la encuesta");
      }
    }
  },
  computed: {
    ...mapGetters({
      language: "language",
      program: "program",
      postulation: "postulation",
      postulationIsNull: "postulationIsNull"
    })
  },
  mounted() {
    this.verifyPostulation();

    if (this.postulationIsNull) {
      this.$router.push({ path: `/principal` });
    }

    this.user = this.$store.state.usuario;
    this.loadOthers();

    // console.log(this.program);
    // console.log(this.language);
    // console.log(this.postulation);
  }
};
</script>
